import React, { useContext, useEffect, useState } from "react";
import { navigate } from "gatsby";
import { Helmet } from "react-helmet";
import { Layout as LayoutPage, Menu } from "antd";
import cx from "classnames";
import { HeaderActions } from "../header";
import { getExpiration, isBrowser, validateRecurso, encryptData } from "../../utils/utils";
// @utils
import { useWindowDimensions } from "../../utils/resize";
// @images
import Logo from "../../assets/images/logoIncolmotos.svg";
import Favicon from "../../assets/images/favicon.png";

// @styles
import "antd/dist/antd.css";
import "./styles.scss";
import "@fortawesome/fontawesome-free/css/all.css"

import { AppContext } from "../../contexts/global";
import Wrapper from "../wrapper-permissions";
import { logout } from "../../services/userServices";
import { changeUrl } from '../../utils/utils';

const { Header, Sider, Content } = LayoutPage;

export const Layout = ({ children }) => {
  const { width } = useWindowDimensions();
  const [collapsed, setCollapsed] = useState(false);
  const pathname =
    isBrowser() && window !== "undefined" ? window.location.pathname : "";
  const { user, isLogged, recursos, setUser } = useContext(AppContext);

  useEffect(() => {
    if (recursos && recursos.length) {
      if (!validateRecurso(recursos, pathname)) {
        navigate("/401");
      }
    }
  }, [recursos]);

  useEffect(() => {
    if (user && user['token']) {
      if (!getExpiration(user['token'])) {
        logout()
        setUser({});
      }
    }
  }, [user]);

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target;
      const elementName = target.tagName.toLowerCase();
      const elementId = target.id || "no-id";
      const elementClass = target.className || "no-class";


      window.gtag("event", "click", {
        event_category: "User Interaction",
        event_label: `Element: ${elementName}, ID: ${elementId}, Class: ${elementClass}`,
      });
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <AppContext.Consumer>
      {(theme) =>
        isLogged && (
          <>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Yamaha Colombia</title>
              <meta name="description" />
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
              />
              <link
                href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900"
                rel="stylesheet"
                type="text/css"
              />
              <link
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
                rel="stylesheet"
              />

              <script async src="https://www.googletagmanager.com/gtag/js?id=G-HESE8JC8WL"></script>
              <script>
                {`
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  gtag('config', 'G-HESE8JC8WL');
                `}
              </script>
            </Helmet>
            <LayoutPage>
              <Sider
                trigger={null}
                width="250px"
                collapsible
                collapsed={width <= 720 ? collapsed : !collapsed}
                className={cx({
                  mobile: width <= 720,
                  active: collapsed,
                })}
                collapsedWidth="90px"
              >
                <div className="logo">
                  <img 
                    src={width <= 720 ? (collapsed ? Favicon : Logo) : (!collapsed ? Favicon : Logo)} 
                    alt="Logo"
                    className={width <= 720 ? (collapsed ? "favicon-collapsed" : "logo-expanded") : (!collapsed ? "favicon-collapsed" : "logo-expanded")}
                  />
                </div>
                <Menu
                  mode="inline"
                  defaultSelectedKeys={["/"]}
                  selectedKeys={pathname}
                  selectable={true}
                >
                  <Wrapper
                    element={
                      <Menu.Item
                        key="/"
                        id="sidemenu.inicio"
                        icon={<em className="fa-solid fa-house" />}
                      >
                        <a href="/" data-testid="inicio">
                          Inicio
                        </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="1"
                        id="sidemenu.indicadores"
                        icon={<em className="fa-solid fa-chart-pie" />}
                      >
                        <a href={"https://yamahacolombia.co1.qualtrics.com/login"}
                          target={"_blank"}
                        >Experiencia Cliente - NPS </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="3"
                        id="sidemenu.oportunidades"
                        icon={<em className="fa-solid fa-chart-column" />}
                      >
                        <a
                          href="https://login.pilotsolution.net/"
                          target="_blank"
                        >
                          Oportunidades
                        </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="4"
                        id="sidemenu.edukando"
                        icon={<em className="fa-solid fa-graduation-cap" />}
                      >
                        <a
                          href={process.env.URL_BASE_EDUKANDO_LABTICA_AUTH}
                          onClick={(event) =>{
                            event.preventDefault();
                            changeUrl(event, process.env.URL_BASE_EDUKANDO_LABTICA_AUTH, "modulo.edukando", user)
                          }}
                          target="_blank"
                        >
                          Edukando
                        </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="5"
                        id="sidemenu.simulador"
                        icon={<em className="fa-solid fa-coins" />}
                      >
                        <a
                          href="https://yamaha.coxti.com/auth/login"
                          target="_blank"
                        >
                          Yamaha Servicios Financieros
                        </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="6"
                        id="sidemenu.alistamientos"
                        icon={<em className="fa-solid fa-motorcycle" />}
                      >
                        <a
                          href="https://apps.incolmotos-yamaha.com.co/ActivacionGarantias/Login.aspx"
                          onClick={(event) =>
                            changeUrl(event, "https://apps.incolmotos-yamaha.com.co/ActivacionGarantias/Login.aspx", "modulo.alistamientos", user)
                          }
                          target="_blank"
                        >
                          Activación Garantías
                        </a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="/reportes"
                        id="sidemenu.reportes"
                        icon={<em className="fa-solid fa-file-lines" />}
                      >
                        <a href={"/reportes"}>Reportes</a>
                      </Menu.Item>
                    }
                  />
                  <Wrapper
                    element={
                      <Menu.Item
                        key="/analitica"
                        id="sidemenu.analitica"
                        icon={<em className="fa-solid fa-magnifying-glass-chart" />}
                      >
                        <a href={"/analitica"}>Analítica</a>
                      </Menu.Item>
                    }
                  />
                </Menu>
              </Sider>
              <LayoutPage className="site-layout">
                <Header className="site-layout-background">
                  <div className="ant-layout-header-welcome">
                    <em
                      className={`fa-solid fa-${collapsed ? "ellipsis-vertical" : "bars"
                        }`}
                      onClick={() => setCollapsed(!collapsed)}
                      data-testid="collapsed"
                    />
                    <span className="ant-layout-header-welcome-title">
                      Yamaha Colombia
                    </span>
                  </div>
                  <HeaderActions />
                </Header>
                <Content className="site-layout-background">{children}</Content>
              </LayoutPage>
            </LayoutPage>
          </>
        )
      }
    </AppContext.Consumer>
  );
};
